import { Directive, ElementRef, HostListener, Input } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router';

@Directive({
	selector: '[inputFocus]'
})
export class InputFocus {

    private origCondition = true;
    private currCondition = true;

	constructor(
        private router: Router,
		private elementRef: ElementRef
	){
        this.router.events.forEach(async item => {
            if (item instanceof NavigationEnd) {
              setTimeout(() => {
                this.currCondition = this.origCondition;
                this.setFocus();   
              });
            }
        });
    }

    @Input()
    set inputFocus(condition: boolean) {
        this.origCondition = condition;
        this.currCondition = condition;
    }

    @HostListener('ionBlur', ['$event']) onInpuBlur() {
        this.currCondition = false;
    }

    private setFocus() {
        if(this.currCondition) {
            setTimeout(() => {
                if(this.elementRef.nativeElement.value === '') {
                    this.elementRef.nativeElement.setFocus();
                }
            }, 500);
        }
    }
    
}
